import React, {FC} from "react"

import {InjectIntl, injectIntl} from "@irati/utils/lang"
import {H2, H3} from "@irati/ui/src/Typography"

interface Props extends InjectIntl {
  emoji: string
  id?: string
  small?: boolean
}

const Free: FC<Props> = ({id, emoji, formatMessage, small}) => {
  const savingsTypeHeader = formatMessage({id: "perks.saving.free"})

  const Heading = small ? H3 : H2

  return (
    <Heading id={id} data-test="free">
      {`${emoji} ${savingsTypeHeader}`}
    </Heading>
  )
}

export default injectIntl(Free)
